import { computed } from 'vue'
import { isFunction } from '@/global/utils/utils'
import { useActiveStatus } from '@/modules/road-maintenance-module/winter-service-v2/common/composables/useActiveStatus'
import { useResponsiblePerson } from '@/modules/road-maintenance-module/winter-service-v2/common/composables/useResponsiblePerson'
import { SUBCONTRACTORS_TRANSLATION_NAMESPACE as NS } from '@/modules/road-maintenance-module/winter-service-v2/subcontractors/config/constants'

/**
 * The one field list behind both the operator details and the new operator form -
 * they are the same screen, the buttons above them are what differs.
 */
export function useOperatorFields (options) {
  const { translate, openGeolocationDialogFn } = options || {}

  const { statusItems } = useActiveStatus({ trans: translate })
  const {
    responsiblePersonField,
    responsiblePersonEmailField,
    responsiblePersonPhoneField
  } = useResponsiblePerson()

  // The address is picked on a map, the same way the subcontractor's own address is -
  // the dialog writes it back together with the coordinates the record is stored with.
  const onOpenGeolocationDialog = (event) => {
    if (!isFunction(openGeolocationDialogFn)) {
      return
    }

    openGeolocationDialogFn(event)
  }

  const fields = computed(() => ([
    {
      key: 'name',
      label: translate(`${NS}.operator_name`),
      creatable: true,
      editable: true,
      visible: true
    },
    {
      key: 'oib',
      label: translate(`${NS}.oib`),
      creatable: true,
      editable: true,
      visible: true
    },
    {
      key: 'address',
      label: translate(`${NS}.address`),
      appendIcon: 'mdi-map-marker',
      appendIconClick: onOpenGeolocationDialog,
      creatable: true,
      editable: true,
      visible: true
    },
    {
      key: 'status',
      label: translate(`${NS}.status`),
      type: 'autocomplete',
      items: statusItems.value,
      // A brand new operator has no status to pick yet - the backend starts it off
      // as active - so the field only shows up once the record exists.
      visible: (fieldsRenderer) => !fieldsRenderer?.createMode,
      creatable: true,
      editable: true
    },
    // Typed, all three of them - the contact is a snapshot rather than a link to
    // someone in the people register. See useResponsiblePerson.
    responsiblePersonField(translate(`${NS}.responsible_person`)),
    responsiblePersonEmailField(translate(`${NS}.responsible_person_email`)),
    responsiblePersonPhoneField(translate(`${NS}.responsible_person_phone`))
  ]))

  return {
    fields
  }
}
